import { render, staticRenderFns } from "./ModalImprimir.vue?vue&type=template&id=5d8ee7db"
import script from "./ModalImprimir.vue?vue&type=script&lang=js"
export * from "./ModalImprimir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports